import type { Node as ProsemirrorNode } from 'prosemirror-model';
import { Fragment } from 'prosemirror-model';
import type { EditorView } from 'prosemirror-view';
import type { Observable } from 'rxjs';

import type { LinkNode, OverlayPosition, RtSchemaType } from '@core/prosemirror-legacy';
import type { WysiwygLink } from '@core/wysiwyg-legacy';

import type {
  SchedulerLinksDropdownListController,
  SchedulerLinksDropdownListOpenOptions,
} from './types';

export class SchedulerLinksServiceInternal {
  public currentOrigin: number | HTMLElement;

  constructor(
    private editorView: EditorView,
    private destroy$: Observable<void>,
    private schedulerLinksDropdownListController?: SchedulerLinksDropdownListController,
  ) {}

  public createLinkNode(
    schema: RtSchemaType<typeof LinkNode>,
    linkItem: WysiwygLink,
  ): ProsemirrorNode | null {
    return schema.nodes.scheduler_link.create(
      { ...linkItem, label: '', href: linkItem.url! },
      schema.text(linkItem.url!),
    );
  }

  public openSchedulerLinksDropdownList(
    position: OverlayPosition | DOMRect,
    options?: SchedulerLinksDropdownListOpenOptions,
  ) {
    const { backdropClick$ } = this.schedulerLinksDropdownListController!.open(position, options);
    backdropClick$.subscribe(() => {
      this.closeSchedulerLinksDropdownList();
      this.editorView.focus();
    });
  }

  public closeSchedulerLinksDropdownList(): void {
    this.schedulerLinksDropdownListController!.close();
  }

  public updateSchedulerLinksDropdownListData(from: number, to: number) {
    this.schedulerLinksDropdownListController!.setSelectCallback(
      this.getSelectSchedulerLinksCallback(from, to),
    );
  }

  private getSelectSchedulerLinksCallback(start: number, end: number) {
    return (selectedEl: WysiwygLink) => {
      const {
        state: { schema, tr },
      } = this.editorView;
      const linkNode = this.createLinkNode(schema, selectedEl);
      const fragment = Fragment.from([linkNode!, schema.text(' ')]);
      tr.replaceWith(start, end, fragment);
      this.editorView.dispatch(tr);

      this.closeSchedulerLinksDropdownList();
      this.editorView.focus();
    };
  }
}
